import { ApolloError } from '@apollo/client';
import React from 'react';
import Snackbar from '/packages/shared-components/modal/Snackbar/Snackbar';

export interface ErrorMessageProps {
  errorMsg: string;
  noMargin?: boolean;
}

const ErrorMessage = ({ errorMsg, noMargin = false }: ErrorMessageProps) => {
  // TODO verify why ErrorMessage has a default margin={1}
  /* return (
    <Box m={noMargin ? 0 : 1}>
      <Alert severity="error" variant="filled" sx={{ color: 'error.main', backgroundColor: 'error.light' }}>
        {error.message}
      </Alert>
    </Box>
  ); */

  return <Snackbar content={errorMsg} status="error" variant="subtle" />;
};

export { ErrorMessage };
